// Moves bombers/satellites across the field; each drops ICBMs on a cooldown and
// is removed when it flies off-screen. RNG (target choice) threads through state.

import type { EnemyMissile, FlyingObject } from '../state/types';
import type { IntegrateFlying } from './contracts';
import { add, direction, scale } from '../geometry/vec2';
import { intInRange } from '../rng/mulberry32';
import { aliveTargets } from '../state/targets';
import { waveConfig } from '../waves/waveConfig';
import { FIELD_W, FIXED_DT, FLYING_DROP_INTERVAL } from '../constants';

export const integrateFlying: IntegrateFlying = (state) => {
  if (state.flyingObjects.length === 0) return state;

  const speed = waveConfig(state.wave).speed;
  const targets = aliveTargets(state);
  let rng = state.rng;
  let nextId = state.nextEntityId;
  const flyers: FlyingObject[] = [];
  const dropped: EnemyMissile[] = [];

  for (const f of state.flyingObjects) {
    const pos = add(f.pos, scale(f.vel, FIXED_DT));
    if (pos.x < -40 || pos.x > FIELD_W + 40) continue; // flew off-screen

    let dropCooldown = f.dropCooldown - FIXED_DT;
    if (dropCooldown <= 0 && targets.length > 0) {
      const pick = intInRange(rng, 0, targets.length);
      rng = pick.state;
      const target = targets[pick.value] ?? f.pos;
      dropped.push({
        id: nextId++,
        kind: 'icbm',
        origin: pos,
        pos,
        target,
        vel: scale(direction(pos, target), speed),
        splitAt: null,
      });
      dropCooldown = FLYING_DROP_INTERVAL;
    }
    flyers.push({ ...f, pos, dropCooldown });
  }

  return {
    ...state,
    flyingObjects: flyers,
    enemyMissiles: [...state.enemyMissiles, ...dropped],
    rng,
    nextEntityId: nextId,
  };
};
